import React from 'react';
import { Navigate } from 'react-router-dom';

// authStatus comes from AppContent: "checking" until the startup session check settles.
// Waiting for it, instead of a fixed delay, keeps a slow check (for example a token
// refresh) from sending a signed-in user to the login page.
const PrivateRoute = ({ children, authStatus }) => {
  if (authStatus === 'checking') {
    return <div>Checking authentication...</div>;
  }

  if (authStatus !== 'signed_in') {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default PrivateRoute;
